import React from "react"
import { useMatch } from "react-router-dom"
import { routes } from "router/routes"
import { useSelector } from "react-redux"
import useActiveGuide from "hooks/useActiveClient"
import { StatusPending } from "./StatusPending"
import { StatusInProgress } from "./StatusInProgress"
import { StatusRejected } from "./StatusRejected"
import PropTypes from 'prop-types';

export default function VerificationStatusPage({ children }) {
  const { role } = useSelector((state) => state.user)
  const { isPending, isInProgress, isApproved, isRejected } = useActiveGuide()
  const isSettingsPage = useMatch({ path: routes.proSettingsRootPath(), end: false })
  const isContactSupportPage = useMatch({ path: routes.contactSupportPath(), end: false })
  const isDashboardPage = useMatch({ path: routes.guideDashboardPath(), end: false })
  const isUser = role === "user"
  const isSupportPending = !isDashboardPage && isPending

  if (isUser || isSupportPending || isSettingsPage || isContactSupportPage || isApproved) return children
  if (isPending) return <StatusPending />
  if (isInProgress) return <StatusInProgress />
  if (isRejected) return <StatusRejected />

  return children
}

VerificationStatusPage.propTypes = {
  children: PropTypes.any
};
